import React, { useEffect, useState } from 'react';
import * as Request from '../../common/request';
import { List } from 'antd-mobile'

const PageModel = props => {
	const [equipmentList, setEquipmentList] = useState([]);

	const getEquipmentList = async () => {
		const result = await Request.get({
			url: '/equipment/list'
		});
		if (!result) return;

		const list = result.data.result || [];
		
		let array = [];
		for (let index = 0; index < list.length; index++) {
			array.push({ "text": list[index].imei, "companyId": list[index].companyId,'companyName':list[index].companyName });
		}
		console.log(array);
		setEquipmentList(array);
	};



	useEffect(() => {
		getEquipmentList()
	}, [123]);

	return (
		<List header='所有设备列表(点击快速绑定企业)'>
			{equipmentList.length > 0 && equipmentList.map((item,index) => {
				return (
					<List.Item extra={item.companyId ? item.companyName : ''} key={index} onClick={() => {
						console.log(item);
						if(!item.companyId){
							props.history.push({
								pathname: '/companylist',
								state: {
									imei: item.text,
									companyId: item.companyId
								}
							});
						}
					}}>{item.text}</List.Item>
				)
			})
			}
			
		</List>

		// <Form layout='vertical' style={{ padding: '10px' }}
		// 	onFinish={onFinish}
		// 	footer={
		// 		<Button block type='submit' color='primary' size='large'>
		// 			提交
		// 		</Button>
		// 	}>
		// 	<Form.Item label='设备imei号' name='equipmentImei'>
		// 		<Input placeholder='请输入用户名' clearable />
		// 	</Form.Item>
		// 	<Form.Item label='设备型号' name='equipmentModel'>
		// 		<Input placeholder='请输入' clearable />
		// 	</Form.Item>

		// 	<Form.Item label='设备品牌' name='equipmentBrand'>
		// 		<Input placeholder='请输入' clearable />
		// 	</Form.Item>

		// 	<Form.Item label='此设备当前状态 1正常 2故障 3报废' name='equipmentStaus'>
		// 		<Input placeholder='请输入' clearable />
		// 	</Form.Item>

		// 	<Form.Item label='设备保养周期' name='equipmentUpkeepTime'>
		// 		<Input placeholder='请输入' clearable />
		// 	</Form.Item>
		// </Form>
	);
};

export default PageModel;
